export default {
  currencies: [],
  currencyRates: [],
  currencyRatesAllStore: [],
  loading: true
}
